import { render, staticRenderFns } from "./MMP_Notifications.vue?vue&type=template&id=e713b0d4&scoped=true&"
import script from "./MMP_Notifications.vue?vue&type=script&lang=js&"
export * from "./MMP_Notifications.vue?vue&type=script&lang=js&"
import style0 from "./MMP_Notifications.vue?vue&type=style&index=0&id=e713b0d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e713b0d4",
  null
  
)

export default component.exports